import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const check = async (data: object) => {
  return await POST({
    url: Api.check,
    data,
    showError: false
  })
}

export const registerBind = async (data: object) => {
  return await POST({
    url: Api.registerBind,
    data,
    showError: false
  })
}

export const sendSmsCode = async (data: any) => {
  return await POST({
    url: Api.sendSmsCode,
    data,
    headers: {
      'Client-Id': 'iss_courier_recommend',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}

export const getCodeBySms = async (data: any) => {
  return await POST({
    url: Api.getCodeBySms,
    data,
    headers: {
      'Client-Id': 'iss_courier_recommend',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}

export const getBanner = async (params: any) => {
  return await GET({
    url: Api.getBanner,
    params,
    showError: false
  })
}

export const courierAge = async (params: any) => {
  return await GET({
    url: Api.courierAge,
    params,
    showError: false
  })
}
